@if (impersonation.isActive()) {
  <div class="impersonation-banner" role="alert">
    <span class="impersonation-banner__text">
      Viewing as <strong>{{ impersonation.targetEmail() }}</strong> — actions are performed as this user.
    </span>
    <button type="button" class="impersonation-banner__exit" (click)="impersonation.stop()">
      Exit impersonation
    </button>
  </div>
}
<router-outlet></router-outlet>
<unexpected-error-dialog></unexpected-error-dialog>
<update-prompt></update-prompt>
